import { _ep0, _mw0, command } from "../commandBuilder";
import { AssumeRoleWithWebIdentity$ } from "../schemas/schemas_0";
export class AssumeRoleWithWebIdentityCommand extends command(_ep0, _mw0, "AssumeRoleWithWebIdentity", AssumeRoleWithWebIdentity$) {
}
